// Main API (192.168.0.99 || 139.0.16.52)
// const API = '192.168.1.212'
const API = 'karhutla.gibox.net'
// const API = '10.200.88.148'
export const HOST = API
export const API_ROOT = `https://${HOST}/api/v1`
export const API_KEY = '$2y$12$5QVMuL1Jl43tmCnrwFkLHONCVL/nfG5ux.YaPSA8imdnjtZVDnsWi'

// Chat & Hotspot API
export const HOST_TWO = API
export const API_ROOT_TWO = `https://${HOST_TWO}/api/v1`
export const API_KEY_TWO = '$2y$12$5QVMuL1Jl43tmCnrwFkLHONCVL/nfG5ux.YaPSA8imdnjtZVDnsWi'

// Images API
export const HOST_THREE = API
export const API_ROOT_THREE = `https://${HOST_THREE}/files`
export const API_KEY_THREE = '$2y$12$5QVMuL1Jl43tmCnrwFkLHONCVL/nfG5ux.YaPSA8imdnjtZVDnsWi'

// export const HOST_HOTSPOT = '178.128.118.191'
// export const API_ROOT_HOTSPOT = `http://${HOST_HOTSPOT}:7006`
// export const API_KEY_HOTSPOT = '$2y$12$5QVMuL1Jl43tmCnrwFkLHONCVL/nfG5ux.YaPSA8imdnjtZVDnsWi'

// Socket IO
export const HOST_SOCKET_IO = API
export const HOST_ROOT_SOCKET_IO = `https://${HOST_SOCKET_IO}`

// Predictif AI 192.168.0.98 || 139.0.16.52
export const HOST_PREDICT = API
export const HOST_ROOT_PREDICT = `https://${HOST_PREDICT}/api/v1`
